// extracted by mini-css-extract-plugin
export var details = "Details-module--details--691c2";
export var details__container = "Details-module--details__container--6f0ce";
export var title = "Details-module--title--c38fe";